import Vue from 'vue'
import Router from 'vue-router'
import Init from '@/components/Init'
import Accueil from '@/components/Accueil'
import Identite from '@/components/Identite'
import Coordonnees from '@/components/Coordonnees'
import RegulariteDeSejour from '@/components/RegulariteDeSejour'
import PiecesAJoindre from '@/components/PiecesAJoindre'
import Validation from '@/components/Validation'
import Enregistrement from '@/components/Enregistrement'

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            name: 'Init',
            component: Init
        },
        {
            path: '/accueil',
            name: 'Accueil',
            component: Accueil
        },
        {
            path: '/identite',
            name: 'Identite',
            component: Identite
        },
        {
            path: '/coordonnees',
            name: 'Coordonnees',
            component: Coordonnees
        },
        {
            path: '/regularite-de-sejour',
            name: 'RegulariteDeSejour',
            component: RegulariteDeSejour
        },
        {
            path: '/pieces-a-joindre',
            name: 'PiecesAJoindre',
            component: PiecesAJoindre
        },
        {
            path: '/validation',
            name: 'Validation',
            component: Validation
        },
        {
            path: '/enregistrement',
            name: 'Enregistrement',
            component: Enregistrement
        }
    ],
    scrollBehavior() {
        // Le "return { top: 0 }" qui devrait renvoyer dans le haut de la page ne fonctionne pas a cause de la transition appliqu" sur le router... obligé de passer par cette astuce
        document.getElementById('app').scrollIntoView();
    },
    // Conserve l'historique de navigation avec le navigateur
    mode: 'history',
    hash: false
})



// WEBPACK FOOTER //
// ./src/router/index.js